import React from 'react';
import PropTypes from 'prop-types';
import { ItemShape } from 'types';
import { TableRow } from './SubItem.styles';
import {
  LeadNumberCell,
  CenterCell,
  PrefixPhone,
  DurationCell,
} from '../../../assets/styles/sharedStyles/sharedStyles';
import { formatDuration, formatPhoneNumber, formatDateTime } from 'helpers';
import Eye from '../VisiblityEye/VisiblityEye';
import ExpandLessIcon from '@mui/icons-material/ExpandMore';

const Item = ({
  item: { talk_id, lead_number, start_time, duration, phone_number, logical_status_id, business_status_id },
  addDataToModal,
  isLastOpenItem,
}) => {
  const openModal = () => {
    addDataToModal({ talk_id });
  };

  const handleMouseDown = (e) => {
    if (e.button === 1) {
      window.open(`${window.location.origin}${window.location.pathname}/!${talk_id}`, '_blank');
    }
  };

  return (
    <>
      <TableRow onClick={openModal} onMouseDown={handleMouseDown} isLastOpenItem={isLastOpenItem} key={talk_id}>
        <CenterCell style={{ pointerEvents: 'none' }}>
          <Eye talk_id={talk_id} isLastOpenItem={isLastOpenItem} />
        </CenterCell>

        <LeadNumberCell>
          &nbsp;
          <ExpandLessIcon style={{ opacity: 0 }} />
          {lead_number}
        </LeadNumberCell>
        <CenterCell>
          {phone_number && (
            <>
              <PrefixPhone>{phone_number.startsWith('+48') ? `${phone_number.slice(0, 3)}` : ''}</PrefixPhone>
              {formatPhoneNumber(phone_number)}
            </>
          )}
        </CenterCell>
        <CenterCell>{start_time && <>{formatDateTime(start_time)}</>}</CenterCell>
        <DurationCell>{formatDuration(duration)}</DurationCell>
        <CenterCell>{logical_status_id}</CenterCell>
        <CenterCell>{business_status_id}</CenterCell>
      </TableRow>
    </>
  );
};

Item.propTypes = {
  item: PropTypes.shape(ItemShape),
  addDataToModal: PropTypes.func.isRequired,
};

export default Item;
